import React, { useState, useEffect } from 'react';
import { SingleInput } from '../../Res/BaseInput';
import { ContentBox } from '../ContentBox';
import { ReqRecruitmentContractorCaseInfo, VIEW_CASESTATUS1 } from '../../../../item/ItemRecruitmentContractor';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { DatePickerInput } from 'rc-datepicker';
import moment from 'moment';
import { toRevise } from './ReviseSOPTools';
import { getOnlyDate } from '../../../../item/ItemTools';

/**
 * 校正 “預定上工日
 * @param {*} param0 
 */
export function ReviseResignDate({ item, action, vw_status, setIsLoading }) {
    const [mItem, setItem] = useState({})

    const [caseComment, setCaseComment] = useState("")
    const [caseResignDate, setCaseResignDate] = useState(moment(new Date()).format('YYYY-MM-DD'))
    const [deateError, setDateError] = useState(false)

    const description = "校正 “下工日”"

    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            console.log(item)
            setItem(item)
            var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
            mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
            console.log(mReqRecruitmentContractorCaseInfo)
            setCaseResignDate(moment(mReqRecruitmentContractorCaseInfo.caseResignDate).format('YYYY-MM-DD'))
        }
    }, [item])

    function toCancel() {
        action(VIEW_CASESTATUS1)
    }

    function toAction() {
        toRevise(mItem, "實際下工日已變更", {
            setIsLoading,
            description: getOnlyDate() + " " + description,
            comment: caseComment,
            caseResignDate
        })
    }

    const onChangeCaseOnboardDate = (jsDate, dateString) => {
        //console.log(jsDate)
        //console.log(dateString)
        if (dateString === "Invalid date") {
            setDateError(true)
        } else {
            setDateError(false)
            setCaseResignDate(dateString)
        }
    }

    var superTitle = description
    var title = ""
    var content =
        <>
            <div className="row">
                <div className="col-md-12">
                    {vw_status}
                    <div className="col-md-3">
                        <p>請選擇正確的“實際下工日”</p>
                        <DatePickerInput
                            displayFormat='YYYY/MM/DD'
                            returnFormat='YYYY-MM-DD'
                            onChange={onChangeCaseOnboardDate}
                            value={caseResignDate}
                            className='my-react-component'
                        />
                    </div>
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    <SingleInput title={"本次作業的評論/備註"} val={caseComment} action={setCaseComment} placeholder={"請儘量簡短"} size={6} />
                </div>
            </div>
        </>

    var footer =
        <div className="row text-right ">
            <div className="col-sm-12">
                <CancelSubmitButton cancelAction={toCancel} submitName={"確定"} submitAction={toAction} isRight={true} />
            </div>
        </div>

    return (
        <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    )
}